import { Observable } from 'rxjs'
import { CurrentUser } from '../models/current-user'

export abstract class CurrentUserGateway {
    abstract getCurrentUser(): Observable<CurrentUser>
    abstract getCurrentUserByName(): Observable<CurrentUser>
    abstract isLicenseExpiring(currentUser: CurrentUser): Observable<boolean>
}
